import { render, staticRenderFns } from "./scatterHtml.vue?vue&type=template&id=c825b51c&scoped=true&lang=pug"
import script from "./scatterHtml.vue?vue&type=script&lang=js"
export * from "./scatterHtml.vue?vue&type=script&lang=js"
import style0 from "./scatterHtml.vue?vue&type=style&index=0&id=c825b51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c825b51c",
  null
  
)

export default component.exports